import { wgs2gcjForObject, isEqual } from '@/util/map'
import { datetime } from '@/util'
import carTrack from '@/views/car/track/index'
import { geocoder, latlngFromObject } from '@/components/sl-amap/utils'

import './index.scss'
const valueToV = (v , step = 25) => {
  if (v >= 0 && v <= 100) {
    return Math.ceil(v / step)
  } else {
    return 0
  }
}
const carStatusConv = (d) => {
  d.heartbeatLastTimeText = d.heartbeatLastTime ? datetime(d.heartbeatLastTime) : 'n/a'
  if (d.carBattery !== null) {
    d.carBatteryValue = valueToV(d.carBattery)
    d.carBatteryDisplay = `${d.carBattery}%`
  } else {
    d.carBatteryValue = 0
    d.carBatteryDisplay = 'n/a'
  }

  if (d.gsmWaft !== null) {
    d.gsmWaftValue = d.gsmWaft
    d.gsmWaftDisplay = ['无信号','极弱','较弱','良好','强'][d.gsmWaft]
  } else {
    d.gsmWaftValue = 0
    d.gsmWaftDisplay = '无信号'
  }

  if (d.satelliteWaft !== null) {
    d.satelliteWaftDisplay = d.satelliteWaft
  }else{
    d.satelliteWaftDisplay = ''
  }
}

const courierNameDisplay = (d) => {
  if (d.courier && d.courier.name) {
    return d.courier.name
  } else {
    return ''
  }
}

const carStateDisplay = (d) => {
  if (d.enableState == 0) {
    return '未启用'
  } else if (d.enableState == 2) {
    return '禁用'
  } else if (d.lockState == 1) {
    return '锁定'
  } else if (d.startState == 1) {
    return '行驶中'
  } else {
    return '正常'
  }
}

const carLocationConv = (d) => {
  if(!d.location) d.location = {}
  d.location.recordDatetimeText = d.location.recordDatetime ? datetime(d.location.recordDatetime) : ''
}

export default {
  props: [ 'carNo' ,'location', 'visible' , 'showClose' ],

  data(){
    return {
      data:null,
      address:null,
      status:{}
    }
  },
  created(){
    this.$watch('carNo' , function(nv){
      if(nv){
        this.query()
      }else{
        this.close()
      }
    } , {immediate:true})
  },
  methods:{
    query() {
      this.$request.car(this.carNo).then(resp => {
        this.$utils.valid(resp.data, {
          location: {},
          status: {},
          company: {}
        })

        this.$utils.conv(resp.data, {
          carStateDisplay,
          courierNameDisplay
        })

        this.$utils.conv(resp.data.status, carStatusConv)

        this.$utils.conv(resp.data, carLocationConv)

        this.data = resp.data

        this.status = resp.data.status

        this.updateLocation()
      })
    },
    close(){
      if( this.upLocationHandle ){
        window.clearTimeout( this.upLocationHandle )
        this.upLocationHandle = null
      }
    },
    updateLocation(){
      this.$request.carLocation(this.data.id).then(r => {

        if( !this.carNo ) return

        let data = this.$utils.conv(r.data,{'locationDateTime':'datetime','heartbeatLastTime':'datetime',carStatusConv})
        let requireUpdateAddress = !isEqual(this.data.location, r.data)

        this.data.status = r.data

        if (requireUpdateAddress) {
          let position = new AMap.LngLat(this.location.longitude, this.location.latitude)// latlngFromObject(this.location)

          geocoder(position).then(r => {
            this.address = r
          }, () => {
           
          })
        }


        this.upLocationHandle = window.setTimeout(() => {
          this.updateLocation()
        }, 5 * 1000)
      })
    },
    handleOpenTrack(){
      this.$dialog({
        width: 80,
        transitionNames: ['none', 'none'],
        paddingless: true,
        render: (h) => {
          return h(carTrack, { props: { id: this.data.id } })
        }
      })
    },
    handleClose(){
      this.$emit('close')
    }
  },
  render() {
    const currentData = this.data || {status:{} , company:{} , license:{} , location:{}}
    let visible = !!this.carNo
    return (
      <div class={{"map-car-detail":true,"map-car-detail--visible":visible}}>
        <div class="map-car-detail__header">
          {
            this.showClose ? <div class="map-car-detail__close" on-click={this.handleClose}><Icon size={18} type="md-close" /></div> : null
          }
          
          <div class="map-car-detail__status">
            <span title="电量">
              <Icon custom={'i-icon icon-battery'+currentData.status.carBatteryValue} />{currentData.status.carBatteryDisplay}
            </span>
            <span title="信号强度">
              <Icon custom={'i-icon icon-signal-'+currentData.status.gsmWaftValue} />{currentData.status.gsmWaftDisplay}
            </span>
            <span title="卫星数量"><Icon custom='i-icon icon-satellitevariant' />{currentData.status.satelliteWaftDisplay}
            </span>
          </div>
          <div class="map-car-detail__title">{currentData.company.companyName}</div>
          <p>No. {currentData.status.carNo} <span style="margin-left: 5em;"></span></p>
          <p>{currentData.carStateDisplay}</p>
          <button class="map-car-detail__ic-track" on-click={this.handleOpenTrack}>
            <div class="ic">
              <Icon type="md-map" size="22" />
            </div>
            <label>轨迹</label>
          </button>
        </div>
        <div class="map-car-detail__body">
          <sl-detail-list item-style={{'marginBottom':'8px'}} label-width="80px" col={1} label-align="right">
            <sl-detail-list-item label="车牌号">{currentData.license.licenseNo}</sl-detail-list-item>
            <sl-detail-list-item label="快递员">{currentData.courierNameDisplay}</sl-detail-list-item>
            <sl-detail-list-item label="联系方式">{currentData.courier ? currentData.courier.phone : ''}</sl-detail-list-item>
            <sl-detail-list-item label="速度">{currentData.status && currentData.status.speed ? (currentData.status.speed+' km/h') : ''}</sl-detail-list-item>
            <sl-detail-list-item label="当前位置">{this.address}</sl-detail-list-item>
            <sl-detail-list-item label="通信时间">{currentData.status.heartbeatLastTimeText}</sl-detail-list-item>
            <sl-detail-list-item label="定位时间">{currentData.status.locationDateTimeText}</sl-detail-list-item>
            <sl-detail-list-item label="总里程">{currentData.totalMileage ? (currentData.totalMileage+' km') : ''}</sl-detail-list-item>
          </sl-detail-list>
        </div>
      </div>
    )
  }
}